var path = 'src/app/crud/save-submit-button.html';
var html = "<button ng-disabled=\"!valid || !enabled\" type=submit class=\"btn btn-success\"> <i class=\"fa fa-floppy-o\" ng-show=!submitting></i> <i class=\"fa fa-spinner fa-spin\" ng-show=submitting></i> {{text || 'Save'}} </button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/crud/save-submit-button.html
 ** module id = 99
 ** module chunks = 0
 **/